import React, { Component } from "react";

import {
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBSelect,
    MDBSelectInput,
    MDBSelectOptions,
    MDBSelectOption,
    MDBRow,
    MDBCol,
    toast,
} from "mdbreact";

import axios from "../../../../axios";

import { DateTimeInput } from "semantic-ui-calendar-react";

import "react-phone-number-input/style.css";

import PhoneInput, {
    isPossiblePhoneNumber,
    isValidPhoneNumber,
} from "react-phone-number-input";

import $ from "jquery";

import { withTranslation } from "react-i18next";

import SelectSearch, { fuzzySearch } from "react-select-search";

class AddNewResident extends Component {
    constructor(props) {
        super(props);
        this.handleDayChange = this.handleDayChange.bind(this);
        this.handleDayChangeEnd = this.handleDayChangeEnd.bind(this);
        this.state = {
            Email: "",
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            email: this.props.email,
            phoneNumber: this.props.phoneNumber,
            selectedLanguage: this.props.language,
            floor: this.props.floor,
            building: this.props.building,
            receivetext: this.props.receivetext,
            receivephone: this.props.receivephone,
            dateStart:
                this.props.startDate !== ""
                    ? new Intl.DateTimeFormat("en-US", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "numeric",
                          minute: "numeric",
                      }).format(new Date(this.props.startDate))
                    : "",
            oldDateStart: this.props.startDate,
            dateEnd:
                this.props.endDate !== ""
                    ? new Intl.DateTimeFormat("en-US", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "numeric",
                          minute: "numeric",
                      }).format(new Date(this.props.endDate))
                    : "",
            oldDateEnd: this.props.endDate,
            unitID: this.props.unitID,
            guestData: this.props.recentresidents,
            venueID: this.props.venueID,
            loading: false,
            invalidDateEnd: null,
            loadingResend: false,
            languageOptions: [
                { value: "en-us", name: "English" },
                { value: "es-xl", name: "Spanish" },
            ],
            unitID_internal: this.props.unitID_internal,
            invalidDateStart: null,
        };
    }

    componentDidMount() {
        this.getVenueDetails(this.props.venueID);
    }

    // Prevent keyboard input on date fields - only allow calendar selection
 preventDateKeyboardInput = (e) => {
  // Allow tab for accessibility
  if (e.key === 'Tab') {
   return true;
  }
  // Prevent all other keyboard input
  e.preventDefault();
  return false;
 };
 validateEmail = (emailEntered) => {
        this.setState({ loading: true });

        let email = emailEntered.trim();
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: email,
            VenueID: this.props.venueID,
        };
        axios
            .post("/venuemgmtconsole/subscribers/validateEmailAddress", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({
                    firstName: response.data.GivenName,
                    lastName: response.data.FamilyName,
                    phoneNumber: response.data["PhoneNumber.E164"],
                    selectedLanguage: response.data.locale,
                    invalidPhone: undefined,
                });
                this.setState({ loading: false });
            })
            .catch((error) => {
                this.setState({ error: true });
                this.setState({ loading: false });
            });
    };

    getVenueDetails = (index) => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: index,
            UserTimeZone: new Date().getTimezoneOffset(),
        };
        this.setState({
            unitData: undefined,
            expiringData: undefined,
            searchData: undefined,
            value: "",
            duration: undefined,
        });
        axios
            .post("/venuemgmtconsole/venues/listVenueDetails", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({
                    unitData:
                        response.data[index][
                            "Units-Building-Floor-List-GuestNetworks"
                        ],
                    timezone: Math.abs(response.data[index]["TimeZoneOffset"]), //+4
                    duration:
                        response.data[index][
                            "DefaultSubscriptionDurationHours-Guests"
                        ],
                });
                var unitArray = [];
                let optionTemplateUnits = [];
                Object.keys(
                    response.data[index][
                        "Units-Building-Floor-List-GuestNetworks"
                    ]
                ).map((oneKey, i) => {
                    optionTemplateUnits.push(
                        this.state.selectedUnit === oneKey ? (
                            <MDBSelectOption selected value={oneKey}>
                                {oneKey}
                            </MDBSelectOption>
                        ) : (
                            <MDBSelectOption value={oneKey}>
                                {oneKey}
                            </MDBSelectOption>
                        )
                    );
                    return true;
                });
                unitArray.push(
                    <MDBSelect
                        id="selectUnit"
                        getValue={this.resetBuildingForm}
                        className="form-control"
                    >
                        <MDBSelectInput
                            className="selectInput selectUnit"
                            selected="Choose your unit"
                        />
                        <MDBSelectOptions search>
                            {optionTemplateUnits}
                        </MDBSelectOptions>
                    </MDBSelect>
                );
                this.setState({
                    unitForm: unitArray,
                });
            })
            .catch((error) => {
                this.getVenueDetails(index);
                this.setState({ error: true });
            });
    };

    resetBuildingForm = (value) => {
        this.setState({
            buildingForm: (
                <MDBSelect
                    id="selectBuilding"
                    getValue={this.handleSelectChangeBuilding}
                    className="form-control"
                >
                    <MDBSelectInput
                        className="selectInput selectBuilding"
                        selected="Choose your building"
                    />
                </MDBSelect>
            ),
        });
        this.setState({
            floorForm: (
                <MDBSelect
                    id="selectFloor"
                    getValue={this.handleSelectChangeFloor}
                    className="form-control"
                >
                    <MDBSelectInput
                        className="selectInput selectFloor"
                        selected="Choose your floor"
                    />
                </MDBSelect>
            ),
        });
        setTimeout(() => {
            this.handleSelectChangeUnit(value);
        }, 1);
    };

    handleSelectChangeUnit = (value) => {
        this.setState({ selectedUnit: value[0] });

        let buildingArray = [];
        let optionTemplateBuilding = [];
        Object.keys(this.state.unitData[value[0]]).map((oneKey, i) => {
            optionTemplateBuilding.push(
                this.state.selectedBuilding === oneKey ? (
                    <MDBSelectOption selected value={oneKey}>
                        {oneKey}
                    </MDBSelectOption>
                ) : (
                    <MDBSelectOption value={oneKey}>{oneKey}</MDBSelectOption>
                )
            );
            return true;
        });

        buildingArray.push(
            <MDBSelect
                id="selectBuilding"
                getValue={this.handleSelectChangeBuilding}
                className="form-control"
                selected="Choose option"
            >
                <MDBSelectInput
                    className="selectInput selectBuilding"
                    selected="Choose your building"
                />
                <MDBSelectOptions search>
                    {optionTemplateBuilding}
                </MDBSelectOptions>
            </MDBSelect>
        );
        this.setState({
            buildingForm: buildingArray,
        });
    };

    resetFloorForm = (value) => {
        setTimeout(() => {
            this.handleSelectChangeBuilding(value);
        }, 1);
    };

    handleSelectChangeBuilding = (value) => {
        this.setState({ selectedBuilding: value[0] });

        let floorArray = [];
        let optionTemplateFloor = [];
        Object.keys(this.state.unitData[this.state.selectedUnit][value[0]]).map(
            (oneKey, i) => {
                optionTemplateFloor.push(
                    this.state.selectedFloor === oneKey ? (
                        <MDBSelectOption selected value={oneKey}>
                            {oneKey}
                        </MDBSelectOption>
                    ) : (
                        <MDBSelectOption value={oneKey}>
                            {oneKey}
                        </MDBSelectOption>
                    )
                );
                return true;
            }
        );

        floorArray.push(
            <MDBSelect
                id="selectFloor"
                getValue={this.handleSelectChangeFloor}
                className="form-control"
                selected="Choose option"
            >
                <MDBSelectInput
                    className="selectInput selectFloor"
                    selected="Choose your floor"
                />
                <MDBSelectOptions search>
                    {optionTemplateFloor}
                </MDBSelectOptions>
            </MDBSelect>
        );
        this.setState({
            floorForm: floorArray,
        });
    };

    handleSelectChangeFloor = (value) => {
        this.setState({ selectedFloor: value[0] });
    };

    handleSelectChangeLanguage = (value) => {
        this.setState({ selectedLanguage: value });
    };

    submitHandler = (event) => {
        let isUpdated = false;
        let isUpdatedStartDate = false;
        let isUpdatedEndDate = false;
        event.preventDefault();
        event.target.className += " was-validated";
        $("#selectUnit").removeClass("is-invalid");
        $("#selectBuilding").removeClass("is-invalid");
        $("#selectFloor").removeClass("is-invalid");
        $("#selectLanguage").removeClass("is-invalid");
        if (this.state.selectedLanguage === undefined) {
            this.setState({
                invalidLanguage: "Please provide a valid language",
            });
            $("#selectLanguage").addClass("is-invalid");
        } else {
            $("#selectLanguage").addClass("is-valid");
        }
        if (this.state.selectedUnit === undefined) {
            this.setState({ invalidUnit: "Please provide a valid unit" });
            $("#selectUnit").addClass("is-invalid");
        } else {
            $("#selectUnit").addClass("is-valid");
        }
        if (this.state.selectedBuilding === undefined) {
            this.setState({ invalidBuilding: "Please provide a valid unit" });
            $("#selectBuilding").addClass("is-invalid");
        } else {
            $("#selectBuilding").addClass("is-valid");
        }
        if (this.state.selectedFloor === undefined) {
            this.setState({ invalidFloor: "Please provide a valid floor" });
            $("#selectFloor").addClass("is-invalid");
        } else {
            $("#selectFloor").addClass("is-valid");
        }
        if (
            this.state.invalidPhone === null ||
            this.state.invalidPhone !== undefined
        ) {
            this.setState({
                invalidPhone: "Please provide a valid phone number",
            });
            $(".PhoneInput").addClass("is-invalid");
        } else {
            $(".PhoneInput").addClass("is-valid");
        }

        if (
            this.state.firstName !== this.props.firstName ||
            this.state.lastName !== this.props.lastName ||
            this.state.phoneNumber !== this.props.phoneNumber ||
            this.state.selectedLanguage !== this.props.language ||
            this.state.receivephone !== this.props.receivephone
        ) {
            console.log('isUpdated will be set to true');
            console.log('firstName:', this.state.firstName, '!==', this.props.firstName);
            console.log('lastName:', this.state.lastName, '!==', this.props.lastName);
            console.log('phoneNumber:', this.state.phoneNumber, '!==', this.props.phoneNumber);
            console.log('language:', this.state.selectedLanguage, '!==', this.props.language);
            console.log('receivephone:', this.state.receivephone, '!==', this.props.receivephone);
            isUpdated = true;
        } else {
            console.log('isUpdated NOT set - no changes detected');
            console.log('firstName:', this.state.firstName, '===', this.props.firstName);
            console.log('lastName:', this.state.lastName, '===', this.props.lastName);
            console.log('phoneNumber:', this.state.phoneNumber, '===', this.props.phoneNumber);
            console.log('language:', this.state.selectedLanguage, '===', this.props.language);
            console.log('receivephone:', this.state.receivephone, '===', this.props.receivephone);
        }

        if (
            this.state.oldDateStart &&
            !isNaN(new Date(this.state.oldDateStart).getTime()) &&
            new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "numeric",
                minute: "numeric",
            }).format(new Date(this.state.oldDateStart)) !==
            this.state.dateStart
        ) {
            isUpdatedStartDate = true;
        }
        if (
            (this.state.oldDateEnd &&
                !isNaN(new Date(this.state.oldDateEnd).getTime()) &&
                new Intl.DateTimeFormat("en-US", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "numeric",
                    minute: "numeric",
                }).format(new Date(this.state.oldDateEnd)) !== this.state.dateEnd) ||
            (!this.state.oldDateEnd && this.state.dateEnd)
        ) {
            isUpdatedEndDate = true;
        }

        if (
            this.state.invalidPhone === undefined &&
            this.state.firstName !== "" &&
            this.state.lastName !== "" &&
            this.state.selectedLanguage !== undefined &&
            this.state.invalidDate === undefined &&
            this.state.invalidDateEnd === null
        ) {
            console.log('Calling submitModify with isUpdated:', isUpdated);
            this.props.submitModify(
                this.state.email.trim(),
                this.state.firstName.trim(),
                this.state.lastName.trim(),
                this.state.phoneNumber,
                this.state.selectedLanguage,
                this.state.receivetext,
                this.state.receivephone,
                this.state.recentResidents,
                this.state.dateStart,
                this.state.oldDateStart,
                this.state.dateEnd,
                this.state.oldDateEnd,
                this.state.venueID,
                this.state.unitID,
                this.state.building,
                this.state.floor,
                this.props.servicePlanID,
                isUpdated,
                false, // isUpdatedServicePlan
                isUpdatedStartDate,
                isUpdatedEndDate,
                false, // isUpdatedSubscriptionDiscount
                this.state.unitID_internal,
                undefined, // selectedServicePlanName
                this.props.subscriberToken,
                false, // updatedUnit
                this.props.subscriptionDiscount,
                this.props.setupIntentID,
                true // guest
            );
        } else {
            console.log('Validation failed - submitModify NOT called');
            console.log('invalidPhone:', this.state.invalidPhone);
            console.log('firstName:', this.state.firstName);
            console.log('lastName:', this.state.lastName);
            console.log('selectedLanguage:', this.state.selectedLanguage);
            console.log('invalidDate:', this.state.invalidDate);
            console.log('invalidDateEnd:', this.state.invalidDateEnd);
        }
    };
    validateDateTime = (value) => {
        if (!value || value.trim() === "") {
            return null;
        }
        if (/[^0-9/:, APM]/.test(value)) {
            return "Invalid characters in date/time";
        }
        if (!/^\d{2}\/\d{2}\/\d{4}, \d{1,2}:\d{2} [AP]M$/.test(value)) {
            return "Date must be in MM/DD/YYYY, h:mm AM/PM format";
        }
        const parts = value.split(", ");
        const dateParts = parts[0].split("/");
        const timeParts = parts[1].split(" ");
        const [hours, minutes] = timeParts[0].split(":");
        const period = timeParts[1];
        const month = parseInt(dateParts[0], 10);
        const day = parseInt(dateParts[1], 10);
        const year = parseInt(dateParts[2], 10);
        const hour = parseInt(hours, 10);
        const minute = parseInt(minutes, 10);
        if (month < 1 || month > 12) {
            return "Month must be between 01 and 12";
        }
        if (day < 1 || day > 31) {
            return "Day must be between 01 and 31";
        }
        if (year < 2000 || year > 2099) {
            return "Year must be between 2000 and 2099";
        }
        if (hour < 1 || hour > 12) {
            return "Hour must be between 1 and 12";
        }
        if (minute < 0 || minute > 59) {
            return "Minute must be between 00 and 59";
        }
        if (period !== "AM" && period !== "PM") {
            return "Time must end with AM or PM";
        }
        const dateObj = new Date(year, month - 1, day);
        if (
            dateObj.getFullYear() !== year ||
            dateObj.getMonth() !== month - 1 ||
            dateObj.getDate() !== day
        ) {
            return "Invalid date";
        }
        // Check if date/time is in the past
        let hour24 = hour;
        if (period === "PM" && hour !== 12) {
            hour24 = hour + 12;
        } else if (period === "AM" && hour === 12) {
            hour24 = 0;
        }
        const dateTimeObj = new Date(year, month - 1, day, hour24, minute);
        const now = new Date();
        if (dateTimeObj < now) {
            return "Date/time cannot be in the past";
        }
        return null;
    };
    validateDateTimeOnBlur = (name) => {
        const value = this.state[name];
        const error = this.validateDateTime(value);
        if (name === "dateStart") {
            this.setState({ invalidDateStart: error });
        } else if (name === "dateEnd") {
            if (!error && value && this.state.dateStart) {
                const startDate = new Date(this.state.dateStart);
                const endDate = new Date(value);
                if (endDate <= startDate) {
                    this.setState({
                        invalidDateEnd: "End date must be after start date",
                    });
                    return;
                }
            }
            this.setState({ invalidDateEnd: error });
        }
    };
    changeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    changeHandlerPhone = (event) => {
        this.setState({ phoneNumber: event });
        var value = event
            ? isPossiblePhoneNumber(event)
                ? undefined
                : "Please provide a valid phone number"
            : "Phone number required";
        this.setState({ invalidPhone: value });
    };
    toggleCheckboxValueSMS = () => {
        this.setState({ receivetext: !this.state.receivetext });
    };
    toggleCheckboxValueVoice = () => {
        this.setState({ receivephone: !this.state.receivephone });
    };
    createMask = () => {
        this.setState({
            phoneNumber: this.state.phoneNumber.replace(/\D/g, ""),
        });
    };

    setEndDate = (dateStart) => {
        if (dateStart !== null) {
            var endDateDay = new Date(dateStart.valueOf()).getDate() + 1;
            var endDate = new Date(dateStart).setDate(endDateDay);
            if (isNaN(endDate) === true) {
                this.setState({
                    invalidDate:
                        "Please provide a valid date in this format MM/DD/YYYY H:MM AM/PM",
                });
            } else {
                var endDateISO = new Date(endDate)
                    .toISOString()
                    .replace(/:00.000Z/, "");
                if (dateStart !== null && this.state.dateEnd === null) {
                    this.setState({
                        dateEnd: Intl.DateTimeFormat("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                        }).format(new Date(endDateISO)),
                    });
                }
            }
        }
    };
    validateEndDate = (dateEnd) => {
        if (dateEnd !== null) {
            var endDateDay = new Date(dateEnd.valueOf()).getDate() + 1;
            var endDate = new Date(dateEnd).setDate(endDateDay);
            if (isNaN(endDate) === true) {
                this.setState({
                    invalidDateEnd:
                        "Please provide a valid date in this format MM/DD/YYYY H:MM AM/PM",
                });
            } else {
                var endDateISO = new Date(endDate)
                    .toISOString()
                    .replace(/:00.000Z/, "");
                if (dateEnd !== null && this.state.dateEnd === null) {
                    this.setState({ dateEnd: endDateISO });
                }
            }
        }
    };
    handleDayChange(dateStart, modifiers, dayPickerInput) {
        const input = dayPickerInput.getInput();
        this.setState({
            dateStart,
            isEmpty: !input.value.trim(),
            isDisabled: modifiers.disabled === true,
        });
    }

    handleDayChangeEnd = (event, { name, value }) => {
        if (this.state.hasOwnProperty(name)) {
            this.setState({ [name]: value });
        }
        var isISO = value;
        let maxDateDay;
        let maxDate;
        if (this.state.duration === 0) {
            maxDateDay = new Date(this.state.dateStart.valueOf());
            maxDate = new Date(this.state.dateStart).setDate(maxDateDay);
        } else {
            maxDateDay =
                new Date(this.state.dateStart.valueOf()).getHours() +
                this.state.duration;
            maxDate = new Date(this.state.dateStart).setHours(maxDateDay);
        }
        if (this.state.duration !== 0) {
            if (new Date(isISO) > new Date(maxDate)) {
                this.setState({
                    invalidDateEnd:
                        "Date cannot exceed " +
                        this.state.duration +
                        " hours for a Guest",
                });
            } else {
                if (isNaN(new Date(isISO)) === false) {
                    this.setState({ invalidDateEnd: null });
                } else {
                    this.setState({
                        invalidDateEnd:
                            "Please provide a valid date in this format MM/DD/YYYY H:MM AM/PM",
                    });
                }
            }
        }
    };

    submitHandlerResendActivation = (email) => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: this.state.email,
            VenueID: this.props.venueID,
            UserTimeZone: new Date().getTimezoneOffset(),
        };
        this.setState({ loadingResend: true });
        axios
            .post("/venuemgmtconsole/subscribers/resendCodeforTandC", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Resent Confirmation!", {
                        closeButton: false,
                    });
                    this.setState({ loadingResend: false });
                },
                (error) => {
                    toast.error("There was an error", {
                        closeButton: false,
                    });
                    this.setState({ loadingResend: false });
                }
            );
    };
    validateDateTime = (value) => {
        if (!value || value.trim() === "") {
            return null;
        }
        if (/[^0-9/:, APM]/.test(value)) {
            return "Invalid characters in date/time";
        }
        if (!/^\d{2}\/\d{2}\/\d{4}, \d{1,2}:\d{2} [AP]M$/.test(value)) {
            return "Date must be in MM/DD/YYYY, h:mm AM/PM format";
        }
        const parts = value.split(", ");
        const dateParts = parts[0].split("/");
        const timeParts = parts[1].split(" ");
        const [hours, minutes] = timeParts[0].split(":");
        const period = timeParts[1];
        const month = parseInt(dateParts[0], 10);
        const day = parseInt(dateParts[1], 10);
        const year = parseInt(dateParts[2], 10);
        const hour = parseInt(hours, 10);
        const minute = parseInt(minutes, 10);
        if (month < 1 || month > 12) {
            return "Month must be between 01 and 12";
        }
        if (day < 1 || day > 31) {
            return "Day must be between 01 and 31";
        }
        if (year < 2000 || year > 2099) {
            return "Year must be between 2000 and 2099";
        }
        if (hour < 1 || hour > 12) {
            return "Hour must be between 1 and 12";
        }
        if (minute < 0 || minute > 59) {
            return "Minute must be between 00 and 59";
        }
        if (period !== "AM" && period !== "PM") {
            return "Time must end with AM or PM";
        }
        const dateObj = new Date(year, month - 1, day);
        if (
            dateObj.getFullYear() !== year ||
            dateObj.getMonth() !== month - 1 ||
            dateObj.getDate() !== day
        ) {
            return "Invalid date";
        }
        // Check if date/time is in the past
        let hour24 = hour;
        if (period === "PM" && hour !== 12) {
            hour24 = hour + 12;
        } else if (period === "AM" && hour === 12) {
            hour24 = 0;
        }
        const dateTimeObj = new Date(year, month - 1, day, hour24, minute);
        const now = new Date();
        if (dateTimeObj < now) {
            return "Date/time cannot be in the past";
        }
        return null;
    };
    validateDateTimeOnBlur = (name) => {
        const value = this.state[name];
        const error = this.validateDateTime(value);
        if (name === "dateStart") {
            this.setState({ invalidDateStart: error });
        } else if (name === "dateEnd") {
            if (!error && value && this.state.dateStart) {
                const startDate = new Date(this.state.dateStart);
                const endDate = new Date(value);
                if (endDate <= startDate) {
                    this.setState({
                        invalidDateEnd: "End date must be after start date",
                    });
                    return;
                }
            }
            this.setState({ invalidDateEnd: error });
        }
    };
    handleChange = (event, { name, value }) => {
        if (this.state.hasOwnProperty(name)) {
            this.setState({ [name]: value });
        }
    };
    toggleConfirmDeletion = (key) => {
        this.setState({
            toggleConfirm: true,
            modal: !this.state.modal,
        });
    };

    submitDelete = (event) => {
        this.props.submitDelete(
            this.state.email,
            this.state.venueID,
            this.state.unitID,
            this.state.building,
            this.state.floor,
            this.state.recentResidents,
            this.state.oldDateStart,
            this.state.unitID_internal,
            undefined,
            undefined,
            true
        );
    };
    toggle = () => {
        this.setState({
            modal: !this.state.modal,
            modalMessage: !this.state.modalMessage,
        });
    };
    render() {
        const { t } = this.props;
        const FORMAT = "MM/dd/yyyy";
        let maxDateDay;
        let maxDate;
        if (this.state.duration === 0) {
            maxDateDay = new Date(this.state.dateStart.valueOf()).getDate();
            maxDate = new Date(this.state.dateStart).setDate(maxDateDay);
        } else {
            maxDateDay =
                new Date(this.state.dateStart.valueOf()).getDate() +
                this.state.duration / 24;
            maxDate = new Date(this.state.dateStart).setDate(maxDateDay);
        }
        return (
            <>
                {this.state.toggleConfirm ? (
                    <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
                        <MDBModalHeader toggle={this.toggle}>
                            Confirm Deletion
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p>
                                Name:{" "}
                                {this.state.firstName +
                                    " " +
                                    this.state.lastName}
                            </p>
                            <p>Email: {this.state.email}</p>
                            <p>Unit: {this.state.unitID}</p>
                            <p>Building: {this.state.building}</p>
                            <p>Floor: {this.state.floor}</p>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="primary" onClick={this.submitDelete}>
                                Confirm
                            </MDBBtn>
                            <MDBBtn color="primary" onClick={this.toggle}>
                                Close
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                ) : null}
                <MDBModalHeader toggle={this.props.toggleModifyResident}>
                    <h4>
                        {this.props.venueType === "HOTSPOT"
                            ? "View/Modify Local Policy"
                            : t("modifyguest.title")}
                    </h4>
                    <p>* = required</p>
                </MDBModalHeader>
                <MDBModalBody>
                    <form
                        className="needs-validation"
                        onSubmit={this.submitHandler}
                        noValidate
                    >
                        <MDBRow>
                            <MDBCol col="6" sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.email")}
                                </label>
                                <input
                                    disabled
                                    id="email"
                                    className="form-control"
                                    onBlur={(event) =>
                                        this.validateEmail(this.state.email)
                                    }
                                    onChange={(event) =>
                                        this.setState({
                                            email: event.target.value,
                                        })
                                    }
                                    value={this.state.email}
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid email.
                                </div>
                            </MDBCol>
                            <MDBCol col="6"></MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.firstname")}
                                </label>
                                <input
                                    required
                                    name="firstName"
                                    id="firstName"
                                    className={
                                        this.state.loading === true
                                            ? "form-control loading"
                                            : "form-control"
                                    }
                                    onChange={this.changeHandler}
                                    value={this.state.firstName}
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid first name.
                                </div>
                            </MDBCol>
                            <MDBCol sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.lastname")}
                                </label>
                                <input
                                    required
                                    className={
                                        this.state.loading === true
                                            ? "form-control loading"
                                            : "form-control"
                                    }
                                    name="lastName"
                                    id="lastName"
                                    onChange={this.changeHandler}
                                    value={this.state.lastName}
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid last name.
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol col="6" sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewguest.phone")}
                                </label>
                                <PhoneInput
                                    placeholder={t("addnewresident.enterphone")}
                                    value={this.state.phoneNumber}
                                    format={FORMAT}
                                    onChange={this.changeHandlerPhone}
                                    name="phoneNumber"
                                    id="phoneNumber"
                                    className={
                                        this.state.loading === true
                                            ? "form-control loading"
                                            : "form-control"
                                    }
                                    defaultCountry="US"
                                    required
                                    error={
                                        this.state.phoneNumber
                                            ? isValidPhoneNumber(
                                                  this.state.phoneNumber
                                              )
                                                ? undefined
                                                : "Invalid phone number"
                                            : "Phone number required"
                                    }
                                />
                                {this.state.invalidPhone !== null ? (
                                    <div className="invalid">
                                        {this.state.invalidPhone}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </MDBCol>
                            <MDBCol col="6">
                                <div>
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        {t("addnewresident.language")}
                                    </label>
                                    <SelectSearch
                                        id="selectLanguage"
                                        search={true}
                                        filterOptions={fuzzySearch}
                                        options={this.state.languageOptions}
                                        isOptionSelected={true}
                                        classNamePrefix="language-select"
                                        onChange={
                                            this.handleSelectChangeLanguage
                                        }
                                        value={this.state.selectedLanguage}
                                        placeholder={
                                            this.state.selectedLanguage !==
                                            undefined
                                                ? this.state
                                                      .selectedLanguage ===
                                                  "en-us"
                                                    ? "English"
                                                    : "Spanish"
                                                : "Select..."
                                        }
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a valid language.
                                    </div>
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol col="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewguest.unit")}
                                </label>
                                <input
                                    disabled
                                    id="unitID"
                                    className="form-control"
                                    value={this.state.unitID}
                                />
                                <div className="invalid-feedback">
                                    Please provide a unit number.
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol col="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.building")}
                                </label>
                                <input
                                    disabled
                                    id="building"
                                    className="form-control"
                                    value={this.state.building}
                                />
                                <div className="invalid-feedback">
                                    Please provide a building.
                                </div>
                            </MDBCol>
                            <MDBCol col="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.floor")}
                                </label>
                                <input
                                    disabled
                                    id="floor"
                                    className="form-control"
                                    value={this.state.floor}
                                />
                                <div className="invalid-feedback">
                                    Please provide a floor.
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.servicestart")}
                                </label>
                                <br />
                                <DateTimeInput
                                    dateTimeFormat="MM/DD/YYYY, h:mm A"
                                    timeFormat="ampm"
                                    name="dateStart"
                                    placeholder="MM/DD/YYYY"
                                    value={this.state.dateStart}
                                    iconPosition="left"
                                    onChange={this.handleChange}
                                    onBlur={() =>
                                        this.validateDateTimeOnBlur("dateStart")
                                    }
                                    onKeyDown={this.preventDateKeyboardInput}
                                    className="dateTimePicker"
                                    closable={true}
                                    disableMinute="true"
                                    minDate={new Date()}
                                    disabled={
                                        new Date(this.state.dateStart) <
                                        new Date()
                                            ? true
                                            : false
                                    }
                                />
                                <label
                                    for="serviceStart"
                                    className="black-text"
                                    style={{
                                        fontSize: "11px",
                                        position: "relative",
                                        top: "-5px",
                                        left: "0px",
                                    }}
                                >
                                    {this.props.venueType === "HOTSPOT"
                                        ? "Subscriber can use their Wi-Fi password as of this date"
                                        : t("addnewguest.servicestartlabel")}
                                </label>
                            </MDBCol>
                            <MDBCol sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.serviceend")}
                                </label>
                                <DateTimeInput
                                    dateTimeFormat="MM/DD/YYYY, h:mm A"
                                    timeFormat="ampm"
                                    name="dateEnd"
                                    placeholder="MM/DD/YYYY"
                                    value={
                                        isNaN(new Date(this.state.dateEnd)) ===
                                            true &&
                                        this.state.invalidDateEnd === null &&
                                        this.state.dateEnd !== ""
                                            ? Intl.DateTimeFormat("en-US", {
                                                  month: "2-digit",
                                                  day: "2-digit",
                                                  year: "numeric",
                                                  hour: "numeric",
                                                  minute: "numeric",
                                              }).format(
                                                  new Date(this.state.dateEnd)
                                              )
                                            : this.state.dateEnd
                                    }
                                    iconPosition="left"
                                    onChange={this.handleDayChangeEnd}
                                    onBlur={() =>
                                        this.validateDateTimeOnBlur("dateEnd")
                                    }
                                    onKeyDown={this.preventDateKeyboardInput}
                                    className="dateTimePicker"
                                    closable={true}
                                    disableMinute="true"
                                    maxDate={
                                        this.state.duration === 0
                                            ? "0"
                                            : new Date(maxDate)
                                    }
                                    minDate={new Date()}
                                />
                                <label
                                    className="black-text"
                                    style={{
                                        fontSize: "11px",
                                        position: "relative",
                                        top: "-5px",
                                        left: "0px",
                                    }}
                                >
                                    {t("addnewguest.serviceendlabel")}
                                </label>
                                {this.state.invalidDateEnd !== null ? (
                                    <div className="invalid">
                                        {this.state.invalidDateEnd}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </MDBCol>
                        </MDBRow>
                        <div className="text-right submitButton">
                            <MDBBtn
                                color="danger"
                                onClick={this.toggleConfirmDeletion}
                            >
                                {this.props.loadingDelete === true ? (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                ) : (
                                    "Delete Guest"
                                )}
                            </MDBBtn>
                            <MDBBtn
                                color="danger"
                                onClick={this.submitHandlerResendActivation}
                            >
                                {this.state.loadingResend === true ? (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                ) : (
                                    t("residentnav.resendactivation")
                                )}
                            </MDBBtn>
                            <MDBBtn color="danger" type="submit">
                                {this.props.loading === true ? (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                ) : this.props.venueType === "HOTSPOT" ? (
                                    "Save Changes"
                                ) : (
                                    t("modifyguest.modifyguest")
                                )}
                            </MDBBtn>
                        </div>
                    </form>
                </MDBModalBody>
            </>
        );
    }
}

export default withTranslation()(AddNewResident);
